import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  main: false
}

const mutations = {
  [types.SHOW_MODAL] (state) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
     state.main = true;
    //  localStorage.setItem('produtoAtivo', JSON.stringify(produto));
  },
  [types.HIDE_MODAL] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = false;
    //  localStorage.removeItem('produtoAtivo');
  },

}

export default {
  state,
  mutations
}

